import { render, staticRenderFns } from "./OwarmList.vue?vue&type=template&id=a63054ec"
import script from "./OwarmList.vue?vue&type=script&lang=js"
export * from "./OwarmList.vue?vue&type=script&lang=js"
import style0 from "./OwarmList.vue?vue&type=style&index=0&id=a63054ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports